import React, { useState, useEffect, useRef } from "react";
import gearIcon from "./img/gear.png";

import Button from "react-bootstrap/Button";
import Offcanvas from "react-bootstrap/Offcanvas";
import { Form } from "react-bootstrap";

import DatePicker, { registerLocale, setDefaultLocale } from "react-datepicker";
import { de } from "date-fns/locale/de";
registerLocale("de", de);

export default function StatistikOptionen({
   getData,
   userObjects,
   benutzerOptionen,
   setBenutzerOptionen,
   setBenutzerListOptionen,
   benutzerListOptionen,
   getNotarTermine,
   initialshow,
   placement,
   timeLimits,
   setTimeLimits,
}) {
   const [show, setShow] = useState(initialshow);

   function addToUserList(e) {
      setBenutzerListOptionen((prev) => ({ ...prev, [e.target.value]: true }));
   }

   return (
      <div className="flex-row m-3">
         {userObjects && (
            <>
               <div className="me-5">
                  <Form className="mt-2 mb-2">
                     <Form.Select
                        value={benutzerOptionen}
                        onChange={(e) => {
                           return setBenutzerOptionen(e.target.value);
                        }}
                     >
                        <option value={"inkl"}> Wessen Daten sollen angezeigt werden</option>

                        <option value={"exkl"}>Wessen Daten sollen nicht angezeigt werden</option>
                     </Form.Select>
                  </Form>
               </div>
               <div className="me-5">
                  <Form className="mt-2 mb-2">
                     <Form.Select value={""} onChange={(e) => addToUserList(e)}>
                        <option></option>
                        {Object.keys(userObjects)
                           .sort((a, b) => {
                              if (
                                 userObjects[a].Nachname + userObjects[a].Vorname <
                                 userObjects[b].Nachname + userObjects[b].Vorname
                              )
                                 return -1;
                              if (
                                 userObjects[a].Nachname + userObjects[a].Vorname >
                                 userObjects[b].Nachname + userObjects[b].Vorname
                              )
                                 return 1;
                              return 0;
                           })
                           .map((user) => (
                              <option key={"userOpt_" + user} value={user}>
                                 {userObjects[user].Nachname + " " + userObjects[user].Vorname}
                              </option>
                           ))}
                     </Form.Select>
                  </Form>
                  {Object.keys(benutzerListOptionen).map((selecteduser) => (
                     <button
                        key={"selectedUserOpt_" + selecteduser}
                        className="benutzer-button"
                        name={selecteduser}
                        onClick={(e) =>
                           setBenutzerListOptionen((prev) => {
                              const newBenutzerOptionen = structuredClone(prev);
                              delete newBenutzerOptionen[selecteduser];
                              return newBenutzerOptionen;
                           })
                        }
                     >
                        {userObjects[selecteduser].Nachname + " " + userObjects[selecteduser].Vorname} ×
                     </button>
                  ))}
               </div>
            </>
         )}

         <div /* style={{ textAlign: "center" }} */>
            <Button style={{ width: "280px" }} onClick={() => getData()}>
               aktualisieren
            </Button>
         </div>
      </div>
   );
}
